export default __webpack_public_path__ + "static/media/main.9cfa8a46.png";